import SageLogoGenericRound from './sage-logo-generic-round';

export * from './sage-logo-generic-round';
export default SageLogoGenericRound;
